export default "../../src/img/tex1.png";